module.exports = __webpack_public_path__ + "prod/20260402160127/img/url-app.d88da72d.png";